import { useCallback } from 'react';
import getAxios from 'getAxios';

const useOffboardReasons = () => {
  return useCallback(async (locationId: number) => {
    try {
      const api = getAxios();
      const response = await api({
        url: `/v3/admin/locations/${locationId}/offboard/reasons`,
        method: 'GET',
      });

      return response.data.map((reason: { value: string; label: string }) => ({
        value: reason.value,
        label: reason.label,
      }));
    } catch (error: any) {
      throw new Error('An error occurred while fetching offboard reasons');
    }
  }, []);
};

export default useOffboardReasons;
